import { AdTabProps } from "./tab";

enum AdTabsEnum {
  LiveSex = "LiveSex",
  RedGIFsAI = "RedGIFsAI",
}

type AdTabsProps = {
  [name in AdTabsEnum]: AdTabProps;
};

export const tabs: AdTabsProps = {
  [AdTabsEnum.LiveSex]: {
    link: "https://rgcams.com/landing/click/?AFNO=1-1",
  },
  [AdTabsEnum.RedGIFsAI]: {
    link: "https://a.aivanta76.com/3f5efc3b-2c2b-4963-bc39-d625144bf94d?adg=0&creative=ai_porn&spot=desktop_tab",
  },
};
